import { render, staticRenderFns } from "./ParkingSpaceList.vue?vue&type=template&id=f329e7c4&"
import script from "./ParkingSpaceList.vue?vue&type=script&lang=js&"
export * from "./ParkingSpaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports